import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    searchValue: '',
    page: 'Projects',
    connected: false,
    login: '',
    pass: '',
    role: '',
    error: false,
    msgError: '',
    alert: false,
    msgAlert: '',
    loading: false,
    avancement: 0,
    menuPDFVisible: false,
    menuXLSVisible: false,
    solvencyChecklist1: process.env.REACT_APP_STEP2_SOLVENCY_CHECK_1,
    solvencyChecklist2: process.env.REACT_APP_STEP2_SOLVENCY_CHECK_2,
    jems32: true,
    isMapVisible: true,
    letterLoaded: false
}

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setSearchValue: (state, action) => {
            state.searchValue = (action.payload);
        },
        setPage: (state, action) => {
            state.menuVisible = false;
            state.page = (action.payload);
        },
        setLogin: (state, action) => {
            state.login = (action.payload);
        },
        setPass: (state, action) => {
            state.pass = (action.payload);
        },
        connectUser: (state, action) => {
            state.connected = action.payload;
        },
        setError: (state, action) => {
            state.error = true;
            state.msgError = action.payload;
        },
        resetError: (state, action) => {
            state.error = false;
            state.msgError = '';
        },
        setAlert: (state, action) => {
            state.alert = true;
            state.msgAlert = action.payload;
        },
        resetAlert: (state, action) => {
            state.alert = false;
            state.msgAlert = '';
        },
        loadingStart: (state, action) => {
            state.loading = true;
        },
        loadingEnd: (state, action) => {
            state.loading = false;
        },
        setAvancement: (state, action) => {
            let status = action.payload;
            state.avancement = Math.round(Number(status.nb) * 100 / Number(status.total));
        },
        showMenuPDF: (state, action) => {
            state.menuPDFVisible = action.payload;
        },
        showMenuXLS: (state, action) => {
            state.menuXLSVisible = action.payload;
        },
        setRole: (state, action) => {
            state.role = action.payload;
        },
        setJems32: (state, action) => {
            state.jems32 = action.payload;
        }
    }
}
)

export const { setSearchValue,
    setPage,
    setLogin,
    setPass,
    connectUser,
    setAlert,
    resetAlert,
    setError,
    resetError,
    loadingStart,
    loadingEnd,
    showMenuPDF,
    showMenuXLS,
    setRole,
    setJems32,
    setAvancement } = appSlice.actions;
export default appSlice.reducer
